import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import Moment from 'react-moment';
import { CSVLink } from "react-csv";
import { getDeHubOrdersList } from '../../api/apiService';
import { ToastError, ToastSuccess } from '../../component/toast-notification';
import { Tooltip } from '@mui/material';
import { DeOrderTabs } from './DeOrderTabs';
import { connect } from 'react-redux';
import { palyNotifyTone } from '../../component/notify-tone';
import { loader } from '../../Actions/index';
import store from '../../store';

const DeHubOrderListTable = ({ 
  hubId = null, 
  startDate = null, 
  endDate = null, 
  status = "all", 
  searchTxt = "", 
  orderCunt = () => {}, 
  socketId = null,
  userId = ""
}) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  // Initialize socket connection
  useEffect(() => {
    if (socketId) {
      initSocket(socketId);
    }
  }, [socketId]);

  // const initSocket = (socket) => {
  //   if (!socket) return;
  //   if(hubId) {
  //   socket.on(`${hubId}`, () => {
  //     fetchOrders(false);
  //     palyNotifyTone();
  //   });
  // }else{
  //   socket.on("admin-order-daily-essential", () => {
  //     fetchOrders(false);
  //     palyNotifyTone();
  //   });
  // }
  // };
  const initSocket = (socket) => {
  socket?.on("admin-order-daily-essential", () => {fetchOrders(false); palyNotifyTone();});
};

  const fetchOrders = async (showLoader = true) => {
    setLoading(showLoader);
    store.dispatch(loader(showLoader));
    if (!hubId || typeof hubId !== "string") { hubId = ""; };
    if (!startDate || startDate === undefined) { startDate = ""; };
    if (!endDate || endDate === undefined) { endDate = ""; };
    if (!status || status === undefined) { status = "all"; };
    if (!searchTxt || searchTxt === undefined) { searchTxt = ""; };
    if (!userId || userId === undefined) { userId = ""; };
    try {
      const response = await getDeHubOrdersList(hubId, status, startDate, endDate, currentPage, searchTxt, userId);
      setOrders(response.data?.data || []);
      setTotalPages(response.data?.pageInfo?.maxPageNo || 1);
      orderCunt(response.data?.orderCount || {});
    } catch (error) {
      // console.log("Error fetching orders:", error);
      ToastError("Failed to fetch orders");
    } finally {
      setLoading(false);
      store.dispatch(loader(false));
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [hubId, currentPage, startDate, endDate, status, searchTxt, userId]);

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    setCurrentPage(newPage);
  };

  if (loading) return <div className="text-center">Loading...</div>;

  return (
    <>
      {orders.length < 1 ? (
        <h2 className="text-center">No orders found</h2>
      ) : (
        <div>
          <table className="table dash-table table-hover text-secondary">
            <thead>
              <tr className="text-left">
                <th>Date/Amount</th>
                <th>Order Id/Type</th>
                <th>User</th>
                <th>Outlet</th>
                <th>Payment Mode</th>
                <th>Payment Status</th>
                <th>Order Status</th>
                <th className="text-center">Delivery Status</th>
              </tr>
            </thead>
            <tbody>
              {orders.length > 0 && orders.map((item) => (
                <tr key={item._id} className="text-left">
                  <td>
                    <Moment format="DD-MM-YY HH:mm">
                      {item.createdDate}
                    </Moment>
                    <br />
                    <span className="font-12"> Amount <span className="font-12 badge badge-info">₹{item.orderAmount}</span></span>
                  </td>
                  <td>
                    <Link to={`/orders/daily-essential/order-details/${item.orderId}`}>{item.orderId}</Link><br />
                    <span className={item.orderType === 0 ? "text-success" : "text-warning"}>
                      {item.orderType === 0 ? "Normal" : "Auction"}
                    </span>
                  </td>
                  <td>
                    <Link to={`/users-management/user-details/${item.userId}`}>
                      {item.userId?.full_name}
                    </Link>
                  </td>
                  <td>
                    <Link style={{ fontSize: "15px" }} to={`/daily-essentials/hubs/single-hub?hubId=${item.hubId?._id}`}>
                      {item.outletId?.hub_name}
                    </Link>
                    <br />
                    <span className="font-12">{item.pickUpAddress.landmark}</span>
                  </td>
                  <td>{item.paymentMode}</td>
                  <td>
                    <span className={`badge ${item.paymentStatus === "SUCCESS" ? "badge-success" : "badge-danger"}`}>
                      {item.paymentStatus}
                    </span>
                  </td>
                  <td>
                    <span className={`badge ${
                      item.orderStatus === "completed" ? "badge-success" : 
                      item.orderStatus === "preparing" ? "badge-primary" : 
                      item.orderStatus === "ready-for-pickup" ? "badge-info" : 
                      item.orderStatus === "out-for-delivery" ? "badge-secondary" : 
                      item.orderStatus === "submitted" ? "badge-warning" : "badge-danger"
                    }`}>
                      {item.orderStatus}
                    </span>
                  </td>
                  <td className="text-center">
                    {item.deliveryType === "take_away" ? "Take away" : item.deliveryStatus}
                    <br />
                    <span className="font-12">{item.deliveryPatner}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <ReactPaginate
            previousLabel={'<<'}
            nextLabel={'>>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            pageCount={totalPages}
            onPageChange={handlePageChange}
            containerClassName={'pagination'}
            activeClassName={'active'}
            forcePage={currentPage - 1}
          />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    socketId: state.loaderReducer.socketId
  }
};

export default connect(mapStateToProps)(DeHubOrderListTable);